import { Routes } from "../Routes";

const Main = ()=> {
  return (
    <Routes />
  );
}

export default Main;
